import React from 'react';
import { SupportProvider } from '../context/SupportContext';
import { SupportUnreadProvider } from '../context/SupportUnreadContext';
import SupportChatBubble from './SupportChatBubble';
import { UserRole } from '@features/settings/types/settings.types';
import { useProfile } from '@shared/hooks/useProfile';

interface SupportWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that provides the SupportProvider context
 * and renders the SupportChatBubble for students across the application
 */
const SupportWrapper: React.FC<SupportWrapperProps> = ({ children }) => {
  const { user } = useProfile();
  const isStudent = user?.role === UserRole.STUDENT;

  // If user is not logged in or not a student, just render children
  if (!user) {
    return <>{children}</>;
  }

  return (
    <SupportUnreadProvider>
      <SupportProvider>
        {children}
        {isStudent && <SupportChatBubble />}
      </SupportProvider>
    </SupportUnreadProvider>
  );
};

export default SupportWrapper;
